import React from "react";
import _ from "lodash";
import Swal from "sweetalert2";
import { upload_image } from "../../../functions/api";
import { mediaUrl as imgUrl } from "../../../functions/mediaUrl";

const Field = ({ label, path, type = "text", draft, setField }) => (
  <div className="mb-3">
    <label className="form-label text-sm fw-medium text-secondary">{label}</label>
    <input
      type={type}
      value={_.get(draft, path) ?? ""}
      onChange={(e) => setField(path, e.target.value)}
      className="form-control"
      autoComplete="on"
    />
  </div>
);

const ObjectForm = ({ draft, onChange, imageLoading, setImageLoading }) => {
  const setField = (path, value) => {
    const next = _.cloneDeep(draft);
    _.set(next, path, value);
    onChange(next);
  };

  const handleImageUpload = async (event) => {
    const img = event.target.files[0];
    if (!img) return;
    setImageLoading(true);
    try {
      const data = await upload_image(img);
      if (data?.response?.url) {
        // Weesmedia bij Cancel is acceptabel — consistent met pre-refactor gedrag.
        onChange({
          ...draft,
          media: {
            mediaid: data.response.mediaid,
            url: data.response.url,
            naam: img.name,
            website: data.response.website || "",
          },
        });
      }
    } catch (e) {
      console.error("Error uploading image:", e);
      Swal.fire("Fout!", "Er is een fout opgetreden bij het uploaden van de afbeelding.", "error");
    } finally {
      setImageLoading(false);
    }
  };

  const handleRemoveImage = () =>
    onChange({ ...draft, media: { mediaid: "", naam: "", url: "", website: "" } });

  return (
    <div className="overflow-y-auto flex-1 p-1">

      {/* ── Foto ── */}
      <div className="mb-4 pb-3 border-bottom">
        <input
          type="file"
          accept=".jpeg,.jpg,.png"
          onChange={handleImageUpload}
          disabled={imageLoading}
          className="form-control mb-2"
        />
        {imageLoading && <small className="text-muted">Bezig met uploaden…</small>}
        {draft.media?.url && (
          <div className="d-flex align-items-start gap-3 mt-2">
            <img
              src={imgUrl(draft.media.url)}
              alt="Object"
              style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 6 }}
            />
            <button
              type="button"
              className="btn btn-outline-danger btn-sm"
              onClick={handleRemoveImage}
              disabled={imageLoading}
            >
              Verwijder foto
            </button>
          </div>
        )}
      </div>

      {/* ── Object ── */}
      <p className="text-xs fw-semibold text-uppercase text-muted mb-3" style={{ letterSpacing: '0.08em' }}>Object</p>

      <div className="row g-3 mb-0">
        <div className="col-8"><Field label="Naam" path="naam" draft={draft} setField={setField} /></div>
        <div className="col-4"><Field label="Nummer" path="nummer" type="number" draft={draft} setField={setField} /></div>
      </div>

      <Field label="Adres" path="locatie.adres" draft={draft} setField={setField} />

      <div className="row g-3 mb-0">
        <div className="col-6"><Field label="Huisnummer" path="locatie.huisnummer" draft={draft} setField={setField} /></div>
        <div className="col-6"><Field label="Postcode" path="locatie.postcode" draft={draft} setField={setField} /></div>
      </div>

      <div className="row g-3 mb-0">
      <div className="col-12"><Field label="Plaats" path="locatie.plaats" draft={draft} setField={setField} /></div>
      </div>

      <div className="row g-3 mb-0">
        <div className="col-6"><Field label="Telefoon" path="telefoonnummer" draft={draft} setField={setField} /></div>
        <div className="col-6"><Field label="Bouwjaar" path="bouwjaar" draft={draft} setField={setField} /></div>
      </div>

      {/* ── Contactpersoon ── */}
      <div className="mt-3 pt-3 border-top">
        <p className="text-xs fw-semibold text-uppercase text-muted mb-3" style={{ letterSpacing: '0.08em' }}>Contactpersoon</p>
        <Field label="Naam" path="contactpersoon.naam" draft={draft} setField={setField} />
        <div className="row g-3 mb-0">
          <div className="col-6"><Field label="Telefoon" path="contactpersoon.telefoon" draft={draft} setField={setField} /></div>
          <div className="col-6"><Field label="Email" path="contactpersoon.email" draft={draft} setField={setField} /></div>
        </div>
      </div>

    </div>
  );
};

export default ObjectForm;
